export default __webpack_public_path__ + "f7a63e8dcd0c6fe5eb87fe585d5d60b0.png";